import React from 'react';

export const TOP_TABS = [
  { id: 'all', label: 'All' },
  { id: 'services', label: 'Services' },
  { id: 'learn', label: 'Learn' },
  { id: 'volunteer', label: 'Volunteer' },
  { id: 'give', label: 'Give' }
];

export default function TopTabStrip({ activeTab, onChange }) {
  return (
    <div className="bg-white border-b border-border/60" data-testid="top-tab-strip">
      <div className="desktop-shell px-4 pb-0 flex items-center gap-5 md:gap-7 overflow-x-auto scrollbar-hide">
        {TOP_TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            data-testid={`top-tab-${tab.id}`}
            onClick={() => onChange(tab.id)}
            className={`relative shrink-0 pb-2 pt-1 text-sm md:text-[15px] font-semibold whitespace-nowrap transition-colors ${
              activeTab === tab.id ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            {tab.label}
            {activeTab === tab.id && (
              <span className="absolute left-0 right-0 -bottom-[1px] h-[2.5px] rounded-full bg-primary" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
